import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Payout.css";
import { isEmpty } from "../functions/isEmpty";
import { useLocation, useNavigate, useParams } from "react-router";
import VideoRecorder from "../components/VideoRecorder";
import Spinner from "../components/CTA/Spinner";

export default function Payout({
  isMobile,
  apiURL,
  authToken,
  creators,
  services,
  setReloadPayouts,
  reloadPayouts,
}) {
  let navigate = useNavigate();
  let location = useLocation().pathname;
  const { orderid } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const [bankaccount_bankname, setBankaccount_bankname] = useState("");
  const [bankaccount_holdername, setBankaccount_holdername] = useState("");
  const [bankaccount_iban, setBankaccount_iban] = useState("");
  const [bankaccount_bic, setBankaccount_bic] = useState("");

  const createPayout = async () => {
    setIsLoading(true);
    const resa = await fetch(`${apiURL}/api/payouts/index.php?id=` + orderid, {
      method: "PUT",
      headers: {
        //   Authorization: `Bearer ${authToken?.JWT}`,
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: JSON.stringify({
        order_id: orderid,
        bankaccount_bankname: bankaccount_bankname,
        bankaccount_holdername: bankaccount_holdername,
        bankaccount_iban: bankaccount_iban,
        bankaccount_bic: bankaccount_bic,
      }),
    });

    await resa.text().then((value) => uploadEnds(value));
  };

  const uploadEnds = () => {
    setReloadPayouts(!reloadPayouts);
    setIsLoading(false);
    navigate("/seller");
  };

  return (
    <div className="payout">
      <div className="payout_topnav">
        <div className="payout_topnav_back" onClick={() => navigate("/seller")}>
          <ArrowBack />
        </div>
        <div className="" onClick={() => navigate("/orders/" + orderid)}>
          Auszahlungen
        </div>
      </div>

      {isMobile ? (
        <div className="payout_topnav">
          <div
            className="payout_topnav_back"
            onClick={() => navigate("/orders/" + orderid)}>
            <ArrowBack />
          </div>
          <div
            className="payout_topnav_back_text"
            onClick={() => navigate("/orders/" + orderid)}>
            Auszahlung für Bestellung Nr {orderid}
          </div>
        </div>
      ) : (
        <div className="payout_topnav">
          <div
            className="payout_topnav_left_title"
            onClick={() => navigate("/orders/" + orderid)}>
            <ArrowBackDesktop />
            Auszahlung für Bestellung Nr {orderid}
          </div>
        </div>
      )}

      <div className="payout_body">
        <div className="payout_body_title">
          An welches Konto sollen wir auszahlen?
        </div>
        <div className="payout_body_inputBox">
          <input
            className="payout_body_inputBox_input"
            placeholder="Name der Bank"
            value={bankaccount_bankname}
            onChange={(e) => setBankaccount_bankname(e.target.value)}
          />
        </div>
        <div className="payout_body_inputBox">
          <input
            className="payout_body_inputBox_input"
            placeholder="Name des Kontoinhabers"
            value={bankaccount_holdername}
            onChange={(e) => setBankaccount_holdername(e.target.value)}
          />
        </div>
        <div className="payout_body_inputBox">
          <input
            className="payout_body_inputBox_input"
            placeholder="IBAN"
            value={bankaccount_iban}
            onChange={(e) => setBankaccount_iban(e.target.value)}
          />
        </div>
        <div className="payout_body_inputBox">
          <input
            className="payout_body_inputBox_input"
            placeholder="BIC"
            value={bankaccount_bic}
            onChange={(e) => setBankaccount_bic(e.target.value)}
          />
        </div>
        <div className="payout_body_ctatext">
          Die Auszahlung wird in 24h bearbeitet. Du erhältst eine Email, wenn
          das Geld gesendet wurde.
        </div>
        {isLoading ? (
          <div className="payout_body_cta">
            <Spinner type="white" />
          </div>
        ) : (
          <div className="payout_body_cta" onClick={() => createPayout()}>
            Auszahlung beantragen
          </div>
        )}
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
`;

const ArrowBackDesktop = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
  margin-bottom: -5px;
  margin-right: 5px;
`;
